import React, { Component } from "react";
import axios from "../../../axios";
import qs from "qs";
import Alert from "react-s-alert";
import FormDropdown from "../../../components/FormDropdown";
import { status_aktif } from "../../../constants/general";
import {
	CATEGORY_LIST,
	CATEGORY_SUBMIT_ADD,
	CATEGORY_SUBMIT_EDIT
} from "../endpoints";

import Switch from "react-switch";

const exam_cat_type = [
    { key: "tugas", value: "TUGAS" },
    { key: "exam", value: "UJIAN" }
]

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			exam_cat_id: "",
			exam_cat_name: "",
			exam_cat_type: "",
			isButtonLoading: false,
			isLoading: false,
			isActive:false
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeSwitch = this.handleChangeSwitch.bind(this);
	}

	handleChangeSwitch(e, f) {
		const name = f;
		this.setState({ [name]: e });
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleSubmit() {
		this.setState({ isButtonLoading: true });

		const url =
			this.props.mode === "Tambah" ? CATEGORY_SUBMIT_ADD : CATEGORY_SUBMIT_EDIT;
		

		axios({
			method: "post",
			url: url,
			data: qs.stringify(this.state)
		})
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/exam/category");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isButtonLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	loadData() {
		if (this.props.mode === "Edit") {
			this.setState({ isLoading: true });

			axios({
				method: "get",
				url: CATEGORY_LIST + "/" + this.props.match.params.exam_cat_id
			})
				.then(response => {
					const result = response.data;

					if (result.success) {
						this.setState({
							exam_cat_id: result.data.exam_cat_id,
							exam_cat_type: result.data.exam_cat_type,
							exam_cat_name: result.data.exam_cat_name,
							isActive:result.data.exam_cat_status === '1' ? true : false
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isLoading: false });
				})
				.catch(error => {
					console.log(error);
					Alert.error("Gagal terhubung ke server!");
					this.setState({ isLoading: false });
				});
		}
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="card">
				<div className="card-header">{this.props.mode} Kategori Ujian</div>
				<div className="card-block">
					{this.state.isLoading ? (
						"Memuat Data..."
					) : (
						<div className="form-horizontal animated fadeIn">
							<div className="form-group row">
                                <label className="col-md-2 form-control-label">Tipe Kategori</label>
                                <div className="col-md-4">
                                    <FormDropdown
                                        items={exam_cat_type}
                                        onChange={this.handleChange}
                                        value={this.state.exam_cat_type}
                                        name="exam_cat_type"
                                    />
                                </div>
                            </div>
							<div className="form-group row">
								<label className="col-md-2 form-control-label">
									Nama Kategori
								</label>
								<div className="col-md-10">
									<input
										name="exam_cat_name"
										type="text"
										className="form-control"
										placeholder="Nama Mata Pelajaran"
										onChange={this.handleChange}
										value={this.state.exam_cat_name}
									/>
								</div>
							</div>
							<div className="form-group row">
								<label className="col-md-2 form-control-label">
									Status
								</label>
								<div className="col-md-10">
									<Switch
										onChange={(e)=>this.handleChangeSwitch(e,'isActive')}
										checked={this.state.isActive}
										className="react-switch"
										name={"isActive"}
									/>
								</div>
							</div>
						</div>
					)}
				</div>
				<div className="card-footer">
					<button
						type="button"
						className="btn btn-md btn-primary"
						disabled={this.state.isButtonLoading && "disabled"}
						onClick={this.handleSubmit}
					>
						{this.state.isButtonLoading ? "Loading" : "Simpan"}
					</button>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Exam/Category/Forms.js